import { BookOpenIcon, GraduationCapIcon } from "@phosphor-icons/react";

import { NudgeType } from "@axio/graphql/generated/graphql";

export type NudgeTypeSettings = Record<NudgeType, boolean>;

export type NudgeSettingDefinition = {
  type: NudgeType;
  label: string;
  description: string;
};

export type NudgeCategoryDefinition = {
  key: string;
  title: string;
  description: string;
  icon: typeof BookOpenIcon;
  iconColor: string;
  iconBackground: string;
  items: NudgeSettingDefinition[];
};

export const nudgeCategoryDefinitions: NudgeCategoryDefinition[] = [
  {
    key: "courseUpdates",
    title: "Course Updates",
    description: "Homework, tests",
    icon: BookOpenIcon,
    iconColor: "#2563EB",
    iconBackground: "#DBEAFE",
    items: [
      {
        type: NudgeType.AssignmentDueSoon,
        label: "Homework Due Reminders",
        description: "Alert students before an assignment deadline.",
      },
      {
        type: NudgeType.QuizOpen,
        label: "Test & Quiz Alerts",
        description: "Notify students when a quiz is available to complete.",
      },
    ],
  },
  {
    key: "facultyUpdates",
    title: "Faculty Updates",
    description: "Grades, announcements",
    icon: GraduationCapIcon,
    iconColor: "#7C3AED",
    iconBackground: "#EDE9FE",
    items: [
      {
        type: NudgeType.SubmissionFeedbackReady,
        label: "Grades Posted With Feedback",
        description: "Surface grading and review outcomes that help students stay on track.",
      },
      {
        type: NudgeType.NewAnnouncement,
        label: "Course Announcements",
        description: "Highlight new course or instructor announcements.",
      },
    ],
  },
];

export const allNudgeTypes = nudgeCategoryDefinitions.flatMap((category) => category.items.map((item) => item.type));
